/* DI pdp-v2-sticky-cta */
/* HVAC-073-DI — show from land below gallery; hide while in-page ATC is on screen */

document.addEventListener('DOMContentLoaded', () => {
  const stickyCta = document.querySelector('.pdp-v2-sticky-cta');
  if (!stickyCta) return;

  const sectionId = stickyCta.dataset.sectionId;
  const buyBtn = document.getElementById('ProductSubmitButton-' + sectionId)
    || document.querySelector('[id^="ProductSubmitButton-"]');
  if (!buyBtn) return;

  const gallery = document.querySelector('.pdp-v2-gallery, .product__media-wrapper');
  const atcBlock = document.querySelector('.product-form__buttons') || buyBtn;

  function getHeaderBottom() {
    let max = 0;
    document.querySelectorAll('sticky-header, .shopify-section-group-header-group > div').forEach(el => {
      const rect = el.getBoundingClientRect();
      if (rect.height > 0 && rect.top >= 0 && rect.bottom > max) {
        max = rect.bottom;
      }
    });
    return max || parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 60;
  }

  function applyOffset() {
    const offset = getHeaderBottom();
    stickyCta.style.setProperty('--sticky-cta-offset', offset + 'px');
  }

  function setVisible(visible) {
    const isVisible = stickyCta.classList.contains('is-visible');
    if (isVisible === visible) return;

    stickyCta.classList.toggle('is-visible', visible);
    if (visible) {
      stickyCta.removeAttribute('aria-hidden');
      document.body.classList.add('pdp-v2-has-sticky-cta');
      document.body.style.setProperty('--pdp-v2-sticky-cta-height', stickyCta.offsetHeight + 'px');
    } else {
      stickyCta.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('pdp-v2-has-sticky-cta');
      document.body.style.setProperty('--pdp-v2-sticky-cta-height', '0px');
    }
  }

  function isInViewport(el) {
    if (!el) return false;
    const rect = el.getBoundingClientRect();
    return rect.bottom > 0 && rect.top < window.innerHeight;
  }

  function galleryOverlapsSticky() {
    if (!gallery || window.innerWidth >= 750) return false;
    const galleryRect = gallery.getBoundingClientRect();
    const stickyHeight = stickyCta.offsetHeight || 120;
    return galleryRect.bottom > window.innerHeight - stickyHeight;
  }

  function overlayOpen() {
    if (document.querySelector('#new-header-support-popup.is-open')) return true;
    if (document.querySelector('#Details-menu-drawer-container[open], .menu-drawer-container[open], details.menu-opening')) return true;
    if (document.body.classList.contains('overflow-hidden-mobile') || document.body.classList.contains('overflow-hidden-tablet')) return true;
    if (document.querySelector('.section-header.menu-open')) return true;
    return false;
  }

  function updateVisibility() {
    const overlay = overlayOpen();
    stickyCta.classList.toggle('is-overlay-blocked', overlay);
    if (overlay) {
      setVisible(false);
      return;
    }
    if (isInViewport(atcBlock)) {
      setVisible(false);
      return;
    }
    if (galleryOverlapsSticky()) {
      setVisible(false);
      return;
    }
    setVisible(true);
  }

  applyOffset();
  updateVisibility();
  window.addEventListener('resize', () => {
    applyOffset();
    updateVisibility();
  }, { passive: true });
  document.addEventListener('scroll', updateVisibility, { passive: true });

  const overlayTargets = [
    document.getElementById('Details-menu-drawer-container'),
    document.getElementById('new-header-support-popup'),
    document.body,
    document.querySelector('.section-header')
  ].filter(Boolean);

  if (overlayTargets.length && typeof MutationObserver !== 'undefined') {
    const overlayObserver = new MutationObserver(updateVisibility);
    overlayTargets.forEach((el) => {
      overlayObserver.observe(el, { attributes: true, attributeFilter: ['open', 'class'] });
    });
  }

  const stickyBtn = stickyCta.querySelector('.pdp-v2-sticky-cta__button');
  if (stickyBtn) {
    stickyBtn.addEventListener('click', () => {
      buyBtn.click();
    });
  }
});
